/* eslint-disable */

import type { PartnersLang } from "./types/PartnersLang";

let data: PartnersLang | undefined;

export type { PartnersLang };

export default function PartnersLangFactory(): PartnersLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setPartnersLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/PartnersLangDef").then(({ PartnersLangDef }) => {
      data = PartnersLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/PartnersLangDef").then(({ PartnersLangDef }) => {
      data = PartnersLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/PartnersLangDef").then(({ PartnersLangDef }) => {
      data = PartnersLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/PartnersLangDef").then(({ PartnersLangDef }) => {
      data = PartnersLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

